import { Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { from, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
/* import { FileTypes } from 'src/app/core/models/doc-file.models'; */
import { EndpointName } from 'src/app/core/models/endpoints.models';
import { APIService } from 'src/app/core/services/api.service';
import { DocFileUploaderComponentDialog } from 'src/app/shared/form-elements/file-uploader-dialog/file-uploader-dialog.component';
import { UploadedFile } from 'src/app/shared/form-elements/file-uploader-dialog/file-uploader-dialog.component';

@Component({
  selector: 'doc-file-uploader',
  templateUrl: 'file-uploader.component.html',
  styleUrls: ['file-uploader.component.scss']
})
export class DocFileUploaderComponent implements OnInit, OnDestroy {

  private onDestroyed$ = new Subject();

  @Input() multi = false;
  /* @Input() type: FileTypes | string = FileTypes.personal; */

  @Output() completedUpload: EventEmitter<UploadedFile[]> = new EventEmitter();


  constructor(
    private dialog: MatDialog
  ) { }

  ngOnInit(): void { }

  openUploader() {
    this.dialog.open(DocFileUploaderComponentDialog, {
      data: {
       /*  type: this.type, */
        mult: this.multi,
      },
      height: 'fit-content',
      width: 'fit-content',
      disableClose: true
    }).afterClosed()
      .pipe(takeUntil(this.onDestroyed$))
      .subscribe(r => {if(r) this.completedUpload.emit(r)});
  }

  ngOnDestroy(): void {
    this.onDestroyed$.next();
    this.onDestroyed$.complete();
  }

}



// lastModified: 1618755030569
// lastModifiedDate: Sun Apr 18 2021 19:40:30 GMT+0530 (India Standard Time) {}
// name: "image 12.png"
// size: 1850
// type: "image/png"
// webkitRelativePath: ""
